// =============================================================================
// src/rules/random.js  —  shared random helpers (shuffle, c)
// -----------------------------------------------------------------------------
// SHARED RULES (client + server). These are normal ESM modules the server
// imports directly (via ../rules.js). At launch, a generator concatenates every
// file in this folder into ONE client script (exports stripped) so the browser
// downloads a single file instead of many. Keep each file SELF-CONTAINED (no
// imports, no cross-file calls) so that concatenation always works.
//
// Randomness uses Math.random() on purpose (project decision: no seeded RNG).
// =============================================================================

/**
 * Shuffle an array in place (Fisher–Yates) and return it.
 * @param {any[]} array  Mutated in place.
 * @returns {any[]}      The same array, shuffled.
 */
export function shuffle(array) {
	var mshuffle = array.length, tshuffle, ishuffle;
	while (mshuffle) {
		ishuffle = Math.floor(Math.random() * mshuffle--);
		tshuffle = array[mshuffle];
		array[mshuffle] = array[ishuffle];
		array[ishuffle] = tshuffle;
	}
	return array;
}

/**
 * "choose" — return one of the arguments at random (equal odds).
 * @param {...any} args
 * @returns {any}
 */
export function c() {
	return arguments[Math.floor(Math.random() * arguments.length)];
}
